import styled from 'styled-components';

export const ContainerLogoTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-right: 10px;
  margin-top: 10px;
  margin-left: 10px;
`;

export const ContainerSize = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3px;
`;
